import { Provider } from "./provider/Provider";

const KullanicilarService = {
  kullaniciEkle: ({ adSoyad, eposta, sifre, sifreTekrar, dogumTarihi }) => {
    return Provider({
      nameSurname: adSoyad,
      email: eposta,
      password: sifre,
      passwordAgain: sifreTekrar,
      birthday: dogumTarihi,
      methodName: "Module/Kullanicilar/AddNewUser",
    });
  },
  kullaniciDetay: (kullaniciID) => {
    return Provider({
      userID: kullaniciID,
      methodName: "Module/Kullanicilar/UserDetail",
    });
  },
  kullaniciListesi: ({ baslangic, limit, durum, orderBy }) => {
    return Provider({
      start: baslangic,
      limit: limit,
      userStatus: durum,
      orderBy: orderBy,
      methodName: "Module/Kullanicilar/UserList",
    });
  },
  kullaniciAra: ({ baslangic, limit, ara, type }) => {
    return Provider({
      start: baslangic,
      limit: limit,
      search: ara,
      type: type,
      methodName: "Module/Kullanicilar/SearchUser",
    });
  },
  kullaniciDuzenle: ({ kullaniciID, adSoyad, eposta, dogumTarihi }) => {
    return Provider({
      userID: kullaniciID,
      nameSurname: adSoyad,
      email: eposta,
      birthday: dogumTarihi,
      methodName: "Module/Kullanicilar/PanelEditUser",
    });
  },
  sifreDegistir: ({ kullaniciID, sifre, sifreTekrar }) => {
    return Provider({
      userID: kullaniciID,
      password: sifre,
      passwordAgain: sifreTekrar,
      methodName: "Module/Kullanicilar/PanelChangePassword",
    });
  },
  kullaniciOnayla: (kullaniciID) => {
    return Provider({
      userID: kullaniciID,
      methodName: "Module/Kullanicilar/ApproveUser",
    });
  },
  kullaniciAktiflestir: (kullaniciID) => {
    return Provider({
      userID: kullaniciID,
      methodName: "Module/Kullanicilar/ActivateUser",
    });
  },
  kullaniciDondur: (kullaniciID) => {
    return Provider({
      userID: kullaniciID,
      methodName: "Module/Kullanicilar/FreezeUser",
    });
  },
  // kullaniciSayisi: () => {
  //   return Provider({
  //     methodName: "Module/Kullanicilar/KullaniciSayisi",
  //   });
  // },
};

export default KullanicilarService;
